import { Factory } from '../../interface/factory';

export enum ProductOwnerRefType {
  User = 'User',
  Organization = 'Organization',
}

export class ProductOwnerRef {
  type: ProductOwnerRefType;
  id: string;

  constructor(json: any) {
    this.type = json.type as ProductOwnerRefType;
    this.id = json.id;
  }

  public static getFactory(): Factory<ProductOwnerRef> {
    return new (class implements Factory<ProductOwnerRef> {
      make(json: any): ProductOwnerRef {
        switch (json.type) {
          case ProductOwnerRefType.User:
            return new UserProductOwner(json);
          case ProductOwnerRefType.Organization:
            if (json.ownershipType) {
              const ownershipType = ProductOwnershipTypeRef.getFactory().make(json.ownershipType);
              switch (ownershipType.type) {
                case ProductOwnershipType.Customer:
                  return new CustomerProductOwner(json);
                case ProductOwnershipType.Reseller:
                  return new ResellerProductOwner(json);
                default:
                  throw new Error('Unrecognized product ownership type (' + ownershipType.type + ').');
              }
            }
            return new OrganizationProductOwner(json);
          default:
            throw new Error('Unrecognized product owner type (' + json.type + ').');
        }
      }

      getTableName(): string {
        throw new Error('Product owners are never stored in IndexedDB.');
      }
    })();
  }
}

export class UserProductOwner extends ProductOwnerRef {
  constructor(json: any) {
    super(json);
  }
}

export enum ProductOwnershipType {
  Customer = 'Customer',
  Reseller = 'Reseller',
}

export class ProductOwnershipTypeRef {
  type: ProductOwnershipType;

  constructor(json: any) {
    this.type = json.type as ProductOwnershipType;
  }

  public static getFactory(): Factory<ProductOwnershipTypeRef> {
    return new (class implements Factory<ProductOwnershipTypeRef> {
      make(json: any): ProductOwnershipTypeRef {
        switch (json.type) {
          case ProductOwnershipType.Customer:
            return new CustomerProductOwnershipTypeRef(json);
          case ProductOwnershipType.Reseller:
            return new ResellerProductOwnershipTypeRef(json);
          default:
            throw new Error('Unrecognized product ownership type (' + json.type + ').');
        }
      }

      getTableName(): string {
        throw new Error('Product ownership types are never stored in IndexedDB.');
      }
    })();
  }
}

export class CustomerProductOwnershipTypeRef extends ProductOwnershipTypeRef {
  constructor(json: any) {
    super(json);
  }
}

export class ResellerProductOwnershipTypeRef extends ProductOwnershipTypeRef {
  constructor(json: any) {
    super(json);
  }
}

export class OrganizationProductOwner extends ProductOwnerRef {
  ownershipType?: ProductOwnershipTypeRef;

  constructor(json: any) {
    super(json);
    this.id = json.id;
    this.ownershipType = json.ownershipType ? ProductOwnershipTypeRef.getFactory().make(json.ownershipType) : undefined;
  }
}

export class ResellerProductOwner extends OrganizationProductOwner {
  constructor(json: any) {
    super(json);
  }
}

export class CustomerProductOwner extends OrganizationProductOwner {
  constructor(json: any) {
    super(json);
  }
}
